'use client';

import type { FC } from 'react';
import { useRouter } from 'next/navigation';

import {
    Select,
    SelectContent,
    SelectItem,
} from '@/components/molecules/Select';

import type { IntegrationMenuSelectConfigType } from '@/static/content/pl/integration/integration-side-content';

export interface SelectMenuProps {
    mobileList: IntegrationMenuSelectConfigType[];
}

const SelectMenu: FC<SelectMenuProps> = ({ mobileList }) => {
    const router = useRouter();

    const handleValueChange = (value: string) => {
        const selectedItem = mobileList.find(item => item.id === value);
        if (selectedItem) {
            router.push(selectedItem.href);
        }
    };

    return (
        <Select
            placeholder="Wybierz z listy"
            className="md:!hidden"
            onValueChange={handleValueChange}
        >
            <SelectContent>
                {mobileList.map(({ id, name }) => (
                    <SelectItem
                        key={id}
                        value={id}
                        data-test-id={`section-integration-side-mobile-category-${id}`}
                    >
                        <span className="text-sm font-extrabold">{name}</span>
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
};

export default SelectMenu;
